import React, { useEffect, useState } from 'react';
import styles from '../../styles.module.scss';
import cs from 'classnames';
// import { UserForm } from './UserForm';
import { GroupInfo } from '../../types';
import { getUserStatusStyle } from '../../utils';
import { InPageSpinner } from '../../../../components/spinners/in-page-spinner';
import { ShowWhenTrue } from '../../../../helpers';
import { Input, Select } from 'antd';

const { Option } = Select;

interface UserGroupProps {
    selectedGroupInfo: GroupInfo | null;
    onEdit: (updatedGroup: { id: string; name: string; roles: any[] }) => void;
    onDelete: (groupId: string) => void;
    showLoader: boolean;
    roleList: {id: string, name: string}[];
}

const UserGroupSection: React.FC<UserGroupProps> = ({ selectedGroupInfo, onEdit, onDelete, showLoader, roleList }) => {
    const [groupName, setGroupName] = useState("");
    const [selectedRoles, setSelectedRoles] = useState<{ id: string; name: string }[]>([]);

    useEffect(() => {
        if (selectedGroupInfo) {
            setGroupName(selectedGroupInfo.name);
            setSelectedRoles(selectedGroupInfo.roles);
        }
    }, [selectedGroupInfo]);

    const handleRoleChange = (selectedIds: string[]) => {
        const formattedRoles = roleList.filter(role => selectedIds.includes(role.id));
        setSelectedRoles(formattedRoles);
    };

    const handleEdit = () => {
        if (selectedGroupInfo) {
            onEdit({
                id: selectedGroupInfo.id,
                name: groupName,
                roles: selectedRoles,
            });
        }
    };

    const handleDelete = () => {
        if (selectedGroupInfo) {
            onDelete(selectedGroupInfo.id);
        }
    };

    return (
        <div className={styles['userInfoPane']}>
            <div style={{marginBottom: 40}}>
                <div className={styles['userInfoPaneHeader']}>
                    <p>Group Details</p>
                </div>
                <div
                    className={cs(styles['userInfoFormContainer'])}
                >
                    {showLoader ?
                        <InPageSpinner className={styles['userInfoFormContainerSpinner']} />
                        :
                        selectedGroupInfo ? (
                            <div className={styles["userInfoForm"]}>
                                <label style={{ marginBottom: -18 }}>Group Name</label>
                                <Input
                                    className={styles["groupInputField"]}
                                    name='name'
                                    value={groupName}
                                    onChange={(e) => setGroupName(e.target.value)}
                                    required
                                />
                                <label style={{ marginBottom: -18 }}>Select Roles</label>
                                <Select className="hierarchyWorflowSelect" mode="multiple" value={selectedRoles.map(role => role.id)} onChange={handleRoleChange}>
                                    {roleList.map((role) => (
                                        <Option key={role.id} value={role.id}>
                                            {role.name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        ) : (
                            <span>Select a user</span>
                        )}
                </div>
            </div>

            <ShowWhenTrue show={!showLoader && !!selectedGroupInfo}>
                <div className={styles['userInfoFormActionBtnsContainer']}>
                    <button
                        className={cs('btn btn-lg btn-yellow-transparent', styles['edit-user'])}
                        id="#edit-user"
                        onClick={handleEdit}
                    >
                        Save
                    </button>
                    <button
                        className={cs('btn btn-lg btn-red', styles['delete-user'])}
                        id="#delete-user"
                        onClick={handleDelete}
                    >
                        <img src="/icons/delete.svg" alt="Delete user" />
                    </button>
                </div>
            </ShowWhenTrue>
        </div>
    );
};

export default UserGroupSection;
